import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Flex,
  FormField,
  Modal,
  TextInput,
} from '../../../../components';
import api from '../../../../utils/services';

const propTypes = {
  onBenefitCategoryAdded: PropTypes.func.isRequired,
  isNewOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

// TODO general error handleing
export default function NewPlanBenefitCategory({
  onBenefitCategoryAdded,
  isNewOpen,
  onClose,
}) {
  const [newBenefitCategoryName, setNewBenefitCategoryName] = useState('');
  const handleSubmit = () => {
    if (!newBenefitCategoryName) return;
    api.addPlanBenefitCategory({ name: newBenefitCategoryName })
      .then((response) => {
        setNewBenefitCategoryName('');
        onBenefitCategoryAdded(response);
        onClose();
      });
  };
  return (
    <React.Fragment>
      <Modal
        size="small"
        title="Add Benefit Category"
        isOpen={isNewOpen}
        onClose={onClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
        closeOnClickOutside={false}
        closeOnEscape={false}
        style={{ zIndex: '1700' }}
      >
        <Modal.Body>
          <FormField
            label="Name"
            input={TextInput}
            name="name"
            value={newBenefitCategoryName}
            onChange={e => setNewBenefitCategoryName(e.target.value)}
          />
        </Modal.Body>
        <Modal.Footer>
          <Flex gutterWidth="0.5em">
            <Flex.Item>
              <Button onClick={onClose}>Cancel</Button>
            </Flex.Item>
            <Flex.Item>
              <Button primary onClick={handleSubmit}>Add</Button>
            </Flex.Item>
          </Flex>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}

NewPlanBenefitCategory.propTypes = propTypes;
